import GatewayService from '../GatewayService.js';
var studentVariant = new GatewayService('student-variant');

var fetchStudentVariants = function fetchStudentVariants() {
  var studentIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var variantDisplaySchema = arguments.length > 1 ? arguments[1] : undefined;
  // we can't use the native axios query param object
  // becuase there are multiple 'studentId' entries.
  var params = new URLSearchParams();
  params.append('variantDisplaySchema', variantDisplaySchema);
  studentIds.forEach(function (studentId) {
    params.append('studentIds', studentId);
  });
  return studentVariant.get('studentvariant/list', {
    params: params
  });
}; // Similar method as we have above.
// Difference: POST method used and studentIds passed in the request body to prevent errors from long request URLs


var fetchStudentVariantsBatch = function fetchStudentVariantsBatch() {
  var studentIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var variantDisplaySchema = arguments.length > 1 ? arguments[1] : undefined;
  var params = new URLSearchParams();
  params.append('variantDisplaySchema', variantDisplaySchema);
  return studentVariant.post('studentvariant/batch-get', studentIds, {
    params: params
  });
};

var saveStudentVariants = function saveStudentVariants(students) {
  return studentVariant.post('studentvariant/list', students);
};

export default {
  fetchStudentVariants: fetchStudentVariants,
  fetchStudentVariantsBatch: fetchStudentVariantsBatch,
  saveStudentVariants: saveStudentVariants
};